import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function KidsKarateHeroForm() {
  return <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-2043">
      <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-2044">
        Find the Right Kids Class
      </div>
      <div className="mt-4" data-id="element-2045">
        <LeadForm buttonText="Start With a Trial Class" defaultProgram="Kids Taekwondo (Ages 6+)" showChildAge={true} data-id="element-2046" />
      </div>
    </div>;
}